<template>
  <div>
    <DataTable :value="data.rows">
      <Column v-for="col of data.cols" :field="col.field" :header="col.header" :key="col.field" />
    </DataTable>
  </div>
</template>

<script>

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'

export default {
  name: 'FeralcoPricesList',
  components: {
    DataTable,
    Column,
    Button
  },
  props: {
    data: Object
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/FeralcoPrices/FeralcoPricesList.vue